import { node } from "prop-types"
import { ThemeProvider } from "@planningcenter/tapestry-react"
import { colors } from "components/ui/theme"
import { buttons } from "components/ui/buttons"
import { breakpoints } from "components/ui/breakpoints"
import { boxSizes } from "components/ui/boxSizes"
import { checkboxes } from "components/ui/checkboxes"
import * as logomark from "@planningcenter/icons/paths/logomark"

export const theme = {
  colors: {
    ...colors
  },
  boxSizes: {
    ...boxSizes
  },
  breakpoints: {
    ...breakpoints
  },
  button: {
    ...buttons
  },
  checkbox: {
    ...checkboxes
  },
  fontSizes: [30, 24, 20, 16, 14, 12, 10],
  id: "registrations",
  spinner: {
    color: "var(--t-fill-color-neutral-020)",
    trackColor: "var(--t-fill-color-neutral-060)"
  },
  toggleSwitch: {
    backgroundColor: "var(--success-color)"
  },
  icons: {
    logomark
  }
}

const propTypes = {
  children: node.isRequired
}

export default function RegistrationsThemeProvider({ children }) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
RegistrationsThemeProvider.propTypes = propTypes
